module.exports = __webpack_public_path__ + "img/beibao.d6a18b20.png";